import * as Types from '../../../generated/webapp_gql';

import { gql } from 'graphql.macro';
export type PathwayCoachingVisitFragment = (
  { __typename?: 'CoachingVisitNode' }
  & Pick<Types.CoachingVisitNode, 'uuid' | 'scheduledTime' | 'scheduledDuration'>
);

export type PathwaySessionFragment = (
  { __typename?: 'PathwaySessionNode' }
  & Pick<Types.PathwaySessionNode, 'title' | 'subtitle' | 'state'>
  & { coachingVisit?: Types.Maybe<(
    { __typename?: 'CoachingVisitNode' }
    & PathwayCoachingVisitFragment
  )> }
);

export type PathwayProviderFragment = (
  { __typename?: 'PathwayProviderNode' }
  & Pick<Types.PathwayProviderNode, 'biography'>
  & { provider: (
    { __typename?: 'CoachNode' }
    & Pick<Types.CoachNode, 'uuid' | 'providerType' | 'firstName' | 'lastName' | 'avatar' | 'digitalBio' | 'country' | 'languagePreferences' | 'providerSpecialties'>
  ) }
);

export type PathwayTopicGoalFragment = (
  { __typename?: 'PathwayTopicGoalNode' }
  & Pick<Types.PathwayTopicGoalNode, 'title' | 'icon'>
);

export type RecommendedActivities_AssessmentLinkNode_Fragment = { __typename?: 'AssessmentLinkNode' };

export type RecommendedActivities_CircleSeriesLinkNode_Fragment = { __typename?: 'CircleSeriesLinkNode' };

export type RecommendedActivities_CircleSessionLinkNode_Fragment = { __typename?: 'CircleSessionLinkNode' };

export type RecommendedActivities_CircleTopicLinkNode_Fragment = { __typename?: 'CircleTopicLinkNode' };

export type RecommendedActivities_CourseLinkNode_Fragment = { __typename?: 'CourseLinkNode' };

export type RecommendedActivities_ExternalLinkNode_Fragment = { __typename?: 'ExternalLinkNode' };

export type RecommendedActivities_HrEventLinkNode_Fragment = { __typename?: 'HREventLinkNode' };

export type RecommendedActivities_HrResourceLinkNode_Fragment = { __typename?: 'HRResourceLinkNode' };

export type RecommendedActivities_InternalLinkNode_Fragment = (
  { __typename?: 'InternalLinkNode' }
  & Pick<Types.InternalLinkNode, 'uuid' | 'webValue' | 'image' | 'title' | 'subtitle' | 'path'>
);

export type RecommendedActivities_MeditationLinkNode_Fragment = (
  { __typename?: 'MeditationLinkNode' }
  & Pick<Types.MeditationLinkNode, 'uuid' | 'webValue'>
  & { meditation: (
    { __typename?: 'MeditationNode' }
    & Pick<Types.MeditationNode, 'duration' | 'image' | 'name' | 'slug' | 'isCompleted'>
    & { meditationProgress: Array<(
      { __typename?: 'MeditationProgressNode' }
      & Pick<Types.MeditationProgressNode, 'completedAt'>
    )> }
  ), mediaType?: Types.Maybe<(
    { __typename?: 'MediaTypeNode' }
    & Pick<Types.MediaTypeNode, 'icon' | 'name'>
  )> }
);

export type RecommendedActivities_ProgramLinkNode_Fragment = (
  { __typename?: 'ProgramLinkNode' }
  & Pick<Types.ProgramLinkNode, 'uuid' | 'webValue'>
  & { program: (
    { __typename?: 'ProgramNode' }
    & Pick<Types.ProgramNode, 'duration' | 'image' | 'name' | 'slug' | 'isCompleted'>
    & { programProgress: Array<(
      { __typename?: 'ProgramProgressNode' }
      & Pick<Types.ProgramProgressNode, 'completedAt'>
    )> }
  ), mediaType?: Types.Maybe<(
    { __typename?: 'MediaTypeNode' }
    & Pick<Types.MediaTypeNode, 'icon' | 'name'>
  )> }
);

export type RecommendedActivities_ScreenLinkNode_Fragment = { __typename?: 'ScreenLinkNode' };

export type RecommendedActivitiesFragment = RecommendedActivities_AssessmentLinkNode_Fragment | RecommendedActivities_CircleSeriesLinkNode_Fragment | RecommendedActivities_CircleSessionLinkNode_Fragment | RecommendedActivities_CircleTopicLinkNode_Fragment | RecommendedActivities_CourseLinkNode_Fragment | RecommendedActivities_ExternalLinkNode_Fragment | RecommendedActivities_HrEventLinkNode_Fragment | RecommendedActivities_HrResourceLinkNode_Fragment | RecommendedActivities_InternalLinkNode_Fragment | RecommendedActivities_MeditationLinkNode_Fragment | RecommendedActivities_ProgramLinkNode_Fragment | RecommendedActivities_ScreenLinkNode_Fragment;

export type PathwayAssessmentActivityFragment = (
  { __typename?: 'AssessmentActivityNode' }
  & Pick<Types.AssessmentActivityNode, 'isCompleted'>
  & { assessment?: Types.Maybe<(
    { __typename?: 'AssessmentNode' }
    & PathwayAssessmentFragment
  )> }
);

export type PathwayTopicFragment = (
  { __typename?: 'PathwayTopicNode' }
  & Pick<Types.PathwayTopicNode, 'title' | 'subtitle' | 'description' | 'duration'>
  & { goals: Array<Types.Maybe<(
    { __typename?: 'PathwayTopicGoalNode' }
    & PathwayTopicGoalFragment
  )>>, sessionDetail?: Types.Maybe<(
    { __typename?: 'PathwaySessionNode' }
    & PathwaySessionFragment
  )>, recommendedActivities?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'AssessmentLinkNode' }
    & RecommendedActivities_AssessmentLinkNode_Fragment
  ) | (
    { __typename?: 'CircleSeriesLinkNode' }
    & RecommendedActivities_CircleSeriesLinkNode_Fragment
  ) | (
    { __typename?: 'CircleSessionLinkNode' }
    & RecommendedActivities_CircleSessionLinkNode_Fragment
  ) | (
    { __typename?: 'CircleTopicLinkNode' }
    & RecommendedActivities_CircleTopicLinkNode_Fragment
  ) | (
    { __typename?: 'CourseLinkNode' }
    & RecommendedActivities_CourseLinkNode_Fragment
  ) | (
    { __typename?: 'ExternalLinkNode' }
    & RecommendedActivities_ExternalLinkNode_Fragment
  ) | (
    { __typename?: 'HREventLinkNode' }
    & RecommendedActivities_HrEventLinkNode_Fragment
  ) | (
    { __typename?: 'HRResourceLinkNode' }
    & RecommendedActivities_HrResourceLinkNode_Fragment
  ) | (
    { __typename?: 'InternalLinkNode' }
    & RecommendedActivities_InternalLinkNode_Fragment
  ) | (
    { __typename?: 'MeditationLinkNode' }
    & RecommendedActivities_MeditationLinkNode_Fragment
  ) | (
    { __typename?: 'ProgramLinkNode' }
    & RecommendedActivities_ProgramLinkNode_Fragment
  ) | (
    { __typename?: 'ScreenLinkNode' }
    & RecommendedActivities_ScreenLinkNode_Fragment
  )>>>, assessmentActivity?: Types.Maybe<(
    { __typename?: 'AssessmentActivityNode' }
    & PathwayAssessmentActivityFragment
  )> }
);

export type MemberPathwayFragment = (
  { __typename?: 'MemberPathwayNode' }
  & Pick<Types.MemberPathwayNode, 'state' | 'currentSessionIndex' | 'duration' | 'completionPercent'>
  & { pathwayProvider: (
    { __typename?: 'PathwayProviderNode' }
    & PathwayProviderFragment
  ), pathwayTopics: Array<Types.Maybe<(
    { __typename?: 'PathwayTopicNode' }
    & PathwayTopicFragment
  )>> }
);

export type PathwayAssessmentQuestionFragment = (
  { __typename?: 'AssessmentQuestionNode' }
  & Pick<Types.AssessmentQuestionNode, 'questionKey' | 'id' | 'questionOrder' | 'uuid' | 'questionText' | 'optional' | 'displayCrisisWarning' | 'calloutText'>
  & { responseType: Array<(
    { __typename?: 'AssessmentAnswerNode' }
    & Pick<Types.AssessmentAnswerNode, 'answerText' | 'value'>
  )> }
);

export type PathwayAssessmentFragment = (
  { __typename?: 'AssessmentNode' }
  & Pick<Types.AssessmentNode, 'id' | 'name' | 'displayName'>
  & { assessmentQuestions: Array<(
    { __typename?: 'AssessmentQuestionNode' }
    & PathwayAssessmentQuestionFragment
  )> }
);

export type CareActionsFragment = (
  { __typename?: 'InternalLinkNode' }
  & Pick<Types.InternalLinkNode, 'id' | 'uuid' | 'title' | 'titleTranslationKey' | 'image' | 'subtitle' | 'subtitleTranslationKey' | 'path'>
  & { childLinks?: Types.Maybe<Array<Types.Maybe<(
    { __typename?: 'InternalLinkNode' }
    & Pick<Types.InternalLinkNode, 'uuid' | 'title' | 'titleTranslationKey' | 'path'>
  )>>> }
);

export type PathwayFragment = (
  { __typename?: 'PathwayNode' }
  & Pick<Types.PathwayNode, 'uuid' | 'title' | 'subtitle' | 'description' | 'sessionCount' | 'slug' | 'metadata'>
  & { assessment: (
    { __typename?: 'AssessmentNode' }
    & PathwayAssessmentFragment
  ), memberPathway?: Types.Maybe<(
    { __typename?: 'MemberPathwayNode' }
    & MemberPathwayFragment
  )>, careActions?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'AssessmentLinkNode' } | { __typename?: 'CircleSeriesLinkNode' } | { __typename?: 'CircleSessionLinkNode' } | { __typename?: 'CircleTopicLinkNode' } | { __typename?: 'CourseLinkNode' } | { __typename?: 'ExternalLinkNode' } | { __typename?: 'HREventLinkNode' } | { __typename?: 'HRResourceLinkNode' } | (
    { __typename?: 'InternalLinkNode' }
    & CareActionsFragment
  ) | { __typename?: 'MeditationLinkNode' } | { __typename?: 'ProgramLinkNode' } | { __typename?: 'ScreenLinkNode' }>>> }
);

export type FeaturedProvidersFragment = (
  { __typename?: 'PathwayProviderNode' }
  & Pick<Types.PathwayProviderNode, 'biography' | 'featuredAvatar'>
  & { provider: (
    { __typename?: 'CoachNode' }
    & Pick<Types.CoachNode, 'uuid' | 'avatar' | 'firstName' | 'lastName' | 'digitalBio'>
  ) }
);

export const PathwayAssessmentQuestionFragmentDoc = gql`
    fragment PathwayAssessmentQuestion on AssessmentQuestionNode {
  questionKey
  id
  questionOrder
  uuid
  questionText
  optional
  displayCrisisWarning
  calloutText
  responseType {
    answerText
    value
  }
}
    `;
export const PathwayAssessmentFragmentDoc = gql`
    fragment PathwayAssessment on AssessmentNode {
  id
  name
  displayName
  assessmentQuestions {
    ...PathwayAssessmentQuestion
  }
}
    ${PathwayAssessmentQuestionFragmentDoc}`;
export const PathwayProviderFragmentDoc = gql`
    fragment pathwayProvider on PathwayProviderNode {
  biography
  provider {
    uuid
    providerType
    firstName
    lastName
    avatar
    digitalBio
    country
    languagePreferences
    providerSpecialties
  }
}
    `;
export const PathwayTopicGoalFragmentDoc = gql`
    fragment pathwayTopicGoal on PathwayTopicGoalNode {
  title
  icon
}
    `;
export const PathwayCoachingVisitFragmentDoc = gql`
    fragment pathwayCoachingVisit on CoachingVisitNode {
  uuid
  scheduledTime
  scheduledDuration
}
    `;
export const PathwaySessionFragmentDoc = gql`
    fragment pathwaySession on PathwaySessionNode {
  title
  subtitle
  state
  coachingVisit {
    ...pathwayCoachingVisit
  }
}
    ${PathwayCoachingVisitFragmentDoc}`;
export const RecommendedActivitiesFragmentDoc = gql`
    fragment recommendedActivities on ContentLinkNode {
  ... on InternalLinkNode {
    uuid
    webValue
    image
    title
    subtitle
    path
  }
  ... on ProgramLinkNode {
    uuid
    webValue
    program {
      duration
      image
      name
      slug
      programProgress {
        completedAt
      }
      isCompleted @client
    }
    mediaType {
      icon
      name
    }
  }
  ... on MeditationLinkNode {
    uuid
    webValue
    meditation {
      duration
      image
      name
      slug
      meditationProgress {
        completedAt
      }
      isCompleted @client
    }
    mediaType {
      icon
      name
    }
  }
}
    `;
export const PathwayAssessmentActivityFragmentDoc = gql`
    fragment pathwayAssessmentActivity on AssessmentActivityNode {
  isCompleted
  assessment {
    ...PathwayAssessment
  }
}
    ${PathwayAssessmentFragmentDoc}`;
export const PathwayTopicFragmentDoc = gql`
    fragment pathwayTopic on PathwayTopicNode {
  title
  subtitle
  description
  duration
  goals {
    ...pathwayTopicGoal
  }
  sessionDetail {
    ...pathwaySession
  }
  recommendedActivities {
    ...recommendedActivities
  }
  assessmentActivity {
    ...pathwayAssessmentActivity
  }
}
    ${PathwayTopicGoalFragmentDoc}
${PathwaySessionFragmentDoc}
${RecommendedActivitiesFragmentDoc}
${PathwayAssessmentActivityFragmentDoc}`;
export const MemberPathwayFragmentDoc = gql`
    fragment memberPathway on MemberPathwayNode {
  state
  currentSessionIndex
  duration
  completionPercent
  pathwayProvider {
    ...pathwayProvider
  }
  pathwayTopics {
    ...pathwayTopic
  }
}
    ${PathwayProviderFragmentDoc}
${PathwayTopicFragmentDoc}`;
export const CareActionsFragmentDoc = gql`
    fragment careActions on InternalLinkNode {
  id
  uuid
  title
  titleTranslationKey
  image
  subtitle
  subtitleTranslationKey
  path
  childLinks {
    uuid
    title
    titleTranslationKey
    path
  }
}
    `;
export const PathwayFragmentDoc = gql`
    fragment pathway on PathwayNode {
  uuid
  title
  subtitle
  description
  sessionCount
  slug
  metadata
  assessment {
    ...PathwayAssessment
  }
  memberPathway {
    ...memberPathway
  }
  careActions {
    ...careActions
  }
}
    ${PathwayAssessmentFragmentDoc}
${MemberPathwayFragmentDoc}
${CareActionsFragmentDoc}`;
export const FeaturedProvidersFragmentDoc = gql`
    fragment featuredProviders on PathwayProviderNode {
  biography
  featuredAvatar
  provider {
    ... on CoachNode {
      uuid
      avatar
      firstName
      lastName
      digitalBio
    }
  }
}
    `;